import type { ExtensionsConfigOptions } from '../../types';

export const extConfig: ExtensionsConfigOptions = {
  bold: true,
  italic: true,
  strikethrough: true,
  underline: true,
  bulletList: true,
  orderedList: true,
  horizontalRuler: true,
  link: true,
  emote: true,
  deviation: {
    defaultWidth: 430,
    formMaxWidth: 780,
    canLink: true,
    canAlign: true,
    canConfigure: true,
    canResize: true,
  },
  deviationThumb: {
    defaultWidth: 150,
    canLink: true,
    maxHeight: 600,
    maxWidth: 780,
  },
  gallery: {
    defaultWidth: 430,
    formMaxWidth: 780,
    defaultAlignment: 'center',
    defaultGridItemWidth: 250,
    defaultGridItemHeight: 200,
    defaultLayout: 'grid',
    defaultTorpedoRowHeight: 200,
    defaultLayoutSpacing: 8,
    canLink: true,
  },
  anchor: false,
  blockDragging: false,
  blockquote: true,
  heading: true,
  mention: true,
  paste: true,
  textAlignment: true,
  textColor: false,
  textFont: false,
  textHighlight: false,
  history: true,
  allowUploads: true,
  spinner: true,
  gif: {
    defaultWidth: 780,
    canAlign: true,
    defaultAlignment: 'center',
  },
  indent: {
    captureTab: false,
  },
  daVideo: {
    canAlign: true,
    defaultWidth: 430,
    defaultHeight: 241,
  },
  hashtag: true,
  muro: true,
  characterCount: false,
};

export const extConfigFullscreen: ExtensionsConfigOptions = {
  bold: true,
  italic: true,
  strikethrough: true,
  underline: true,
  bulletList: true,
  orderedList: true,
  horizontalRuler: true,
  link: true,
  emote: true,
  deviation: {
    defaultWidth: 780,
    formMaxWidth: 780,
    canLink: true,
    canAlign: true,
    canConfigure: true,
    canResize: true,
  },
  deviationThumb: {
    defaultWidth: 150,
    canLink: true,
    maxHeight: 600,
    maxWidth: 780,
  },
  gallery: {
    defaultWidth: 780,
    formMaxWidth: 780,
    defaultAlignment: 'center',
    defaultGridItemWidth: 250,
    defaultGridItemHeight: 200,
    defaultLayout: 'grid',
    defaultTorpedoRowHeight: 200,
    defaultLayoutSpacing: 8,
    canLink: true,
  },
  anchor: false,
  blockDragging: true,
  blockquote: true,
  heading: true,
  mention: true,
  paste: true,
  textAlignment: true,
  textColor: false,
  textFont: false,
  textHighlight: false,
  history: true,
  allowUploads: true,
  spinner: true,
  gif: {
    defaultWidth: 780,
    canAlign: true,
    defaultAlignment: 'center',
  },
  indent: {
    captureTab: true,
  },
  daVideo: {
    canAlign: true,
    defaultWidth: 780,
    defaultHeight: 438,
  },
  hashtag: true,
  muro: true,
  characterCount: false,
};
